import React from "react";
import Icon from "components/AppIcon";
import Image from "components/AppImage";
import { useNavigation } from "components/ui/NavigationStateManager";

const ProductCard = ({ product, viewMode = "grid", onClick, currentStore }) => {
  const { getDisplayStoreName, getDisplayProductName } = useNavigation();
  const getProductImage = () => {
    try {
      if (!product) return "";
      let images;
      if (typeof product.aImageJson === "string") {
        images = JSON.parse(product.aImageJson);
      } else if (Array.isArray(product.aImageJson)) {
        images = product.aImageJson;
      } else {
        return "";
      }
      if (!Array.isArray(images)) return "";
      const frontImage = images.find((img) => img?.sTag === "frontImage");
      const frontFullImage = images.find(
        (img) => img?.sTag === "frontFullImage"
      );
      return (
        frontImage?.sURL || frontFullImage?.sURL || images?.[0]?.sURL || ""
      );
    } catch (error) {
      console.warn("Error extracting image URL:", error);
      return "";
    }
  };

  if (viewMode === "list") {
    return (
      <div
        onClick={() => onClick(product)}
        className="bg-surface border border-border rounded-lg p-4 hover:border-secondary-300 hover:shadow-md transition-smooth cursor-pointer"
      >
        <div className="flex items-center space-x-4">
          <div className="w-24 h-24 bg-secondary-100 rounded-lg overflow-hidden flex-shrink-0">
            <Image
              src={getProductImage()}
              alt={getDisplayProductName(product)}
              className="w-full h-full object-contain"
            />
          </div>

          {/* Details */}
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-text-primary text-base truncate">
              {getDisplayProductName(product)}
            </h3>
            <p className="text-sm text-text-secondary mb-2">
              {getDisplayStoreName()}
            </p>
            <div className="text-lg font-semibold text-text-primary">
              ₹{product?.dPrice ? product.dPrice.toFixed(2) : "0.00"}
            </div>
          </div>

          <div className="ml-auto">
            <button className="p-2 text-primary hover:bg-primary-50 rounded-lg transition-smooth">
              <Icon name="ArrowRight" size={16} />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={() => onClick(product)}
      className="bg-surface border border-border rounded-lg overflow-hidden hover:border-secondary-300 hover:shadow-md transition-smooth cursor-pointer group"
    >
      <div className="relative aspect-square bg-secondary-100 overflow-hidden p-3">
        <Image
          src={getProductImage()}
          alt={getDisplayProductName(product)}
          className="w-full h-full object-contain group-hover:scale-105 transition-smooth"
        />
      </div>

      <div className="p-4">
        <div className="mb-2">
          <h3 className="font-medium text-text-primary line-clamp-2 mb-1">
            {getDisplayProductName(product)}
          </h3>
          <p className="text-sm text-text-secondary">{getDisplayStoreName()}</p>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-lg font-semibold text-text-primary">
            ₹{product.dPrice ? product.dPrice : 0}
          </div>
          <button className="p-2 text-primary hover:bg-primary-50 rounded-lg transition-smooth">
            <Icon name="ArrowRight" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
